import { useState } from 'react';
import { createPortal } from 'react-dom';
import { XMarkIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Button } from '../button';
import { IconButton } from '../iconButton';

export interface ConfirmInterface {
  title: string;
  subtitle: string;
  children: ReactNode[];
}

export function Confirm({
  loading,
  title,
  subtitle,
  onConfirm = () => {},
  children,
  zIndex = 'z-[10]'
}: ConfirmInterface) {
  const [opened, setOpened] = useState(false);

  const modalComponent = (
    <div
      data-confirm={true}
      className={`${zIndex} fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center ${opened ? '' : 'pointer-events-none opacity-0'}`}
    >
      <button
        onClick={() => setOpened(false)}
        className="fixed top-0 left-0 right-0 bottom-0 z-[1] bg-white/70"
      ></button>
      <div className="relative z-[2] flex flex-col bg-white ring-1 ring-slate-200/70 rounded-lg shadow-lg p-6 max-w-[600px]">
        <div className="flex space-x-6">
          <div className="pt-2">
            <div className="bg-red-50 rounded-full text-red-600 w-12 h-12 flex items-center justify-center">
              <ExclamationTriangleIcon className="w-8 h-8" />
            </div>
          </div>
          <div className="flex">
            <div>
              <h3 className="text-lg font-hmedium">{title}</h3>
              <p className="leading-[20px]">{subtitle}</p>
            </div>
            <div className="pl-6">
              <IconButton icon={XMarkIcon} onClick={() => setOpened(false)} size="lg" />
            </div>
          </div>
        </div>
        <div className="flex justify-end pt-6 space-x-4">
          <Button onClick={() => setOpened(false)} label="Annuler" />
          <Button
            color="red"
            loading={loading}
            onClick={async e => {
              e.preventDefault();
              e.stopPropagation();
              await onConfirm();
              setOpened(false);
            }}
            label="Confirmer"
          />
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div
        data-confirm={true}
        className="[&_*]:pointer-events-none cursor-pointer"
        onClick={e => setOpened(true)}
      >
        {children}
      </div>
      {createPortal(modalComponent, document.body)}
    </>
  );
}
